export const bsc_test_payment_contract  =  "0x4Cf045B4C687bcc00234cffa57b5857CD4076fe4"
export const bsc_main_payment_contract = "0x3C52337a4150A0A10d70Cc55103A8F24BECAE71a"
export const eth_main_payment_contract = "0x1d44cb58291f23367Dbd5009a261742329852c0e"
export const dummy_token_bsc_test = "0x867cbb155f2bced46768c8d7f4aaa5a2355c9fe3"
export const obi_token_bsc_mainnet = "0x69A87C8788d4a48c1362B3B357d0E6b59c11d93f"
export const obi_token_eth_mainnet = "0xBb3A8FD6Ec4bF0FDc6Cd2739b1e41192D12B1873"
